window.VSEARCH_UTILS = (function() {
  const requires = [
    'products'
  ];
  const ranges = ['price'];
  const restrictions = ['brand', 'promotion'];
  const nonFacetKeys = [
    'q',
    'page',
    'selectedSort',
    'maxPerPage',
    'taxonomyId'
  ];

  function buildAttributes(input) {
    const attributes = {};
    Object.keys(input).forEach(key => {
      if (
        !restrictions.includes(key) &&
        !ranges.includes(key) &&
        !nonFacetKeys.includes(key)
      ) {
        attributes[key] = {
          id: key,
          values: Array.isArray(input[key])
            ? input[key]
            : [input[key]]
        };
      }
    });
    return attributes;
  }

  function getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
        /mobile|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
        ) || window.innerWidth <= 600;

    return isMobile ? 'MOBILE_WEB' : 'DESKTOP';
  }

  function sanitize(url) {
    // Create an anchor element to use the browser's built-in URL parsing
    const parser = document.createElement('a');
    parser.href = url;

    // Rebuild the URL from its components, stripping out any harmful characters
    const protocol = 'https:';
    const host = parser.host.replace(/[^a-zA-Z0-9.-]/g, '');
    const pathname = parser.pathname.replace(/[^a-zA-Z0-9\/._-]/g, '');
    const search = parser.search.replace(/[^a-zA-Z0-9&=_-]/g, '');

    // Return the sanitized URL
    return `${protocol}//${host}${pathname}${search}`;
  }

  return {
    // input = {"2219056": ["2232847"], maxPerPage: 8, taxonomyId: '79194' }
    prepareRequestBodyParams: function(input) {
      const { taxonomyId, maxPerPage } = input;
      const categoryTerm = taxonomyId;
      const attributes = buildAttributes(input);
      const restrictionsObject = {};
      const rangesObject = {};
      const fastshipping = null;
      const oos = null;
      const rating = null;

      return {
        client: {
          id: 'ostk',
          version: '1.0.0',
          deviceType: getDeviceType()
        },
        user: {
          seed: window.Shopify?.seed || '3622946904276041631',
          language: window.Shopify?.locale || 'EN',
          country: window.Shopify?.country || 'US',
          currency: window.Shopify?.currency.active || 'USD',
          zip: window.Shopify?.zip || '',
          zipByIp: window.Shopify?.zipById || '',
          requestId: window.Shopify?.requestId || ''
        },
        query: {
          productSearchQuery: {
            taxonomies: categoryTerm ? [categoryTerm] : [],
            attributes,
            restrictions: restrictionsObject,
            ranges: rangesObject,
            searchParameters: {
              fastshipping,
              oos,
              page: 1,
              sort: 'bestselling',
              rating
            }
          },
          origin: {
            scheme: 'https',
            hostType: 'DomainName',
            host: 'www.overstock.com'
          }
        },
        requires,
        conversationalSearch: {},
        clientProfileOverrides: {
          productCount: {
            rows: +maxPerPage,
            maxSponsoredProducts: 0
          },
          sponsoredShowcaseProductCount: {
            rows: 0,
            maxSponsoredProducts: 0
          }
        },
        verboseLogging: false,
        url: sanitize(window.location.href)
      };
    }
  };
})();
